export default {
  path: '/accounts',
  name: 'accounts',
  component: () => import('../components/Layout'),
  children: [
    {
      name: 'AccountShow',
      path: ':id',
      component: () => import('../views/account/Show')
    }
  ]
}
